export enum IntegracaoProcessoEnum {
  SEM_INTEGRACAO = 'SEM_INTEGRACAO',
  PROTOCOLO = 'PROTOCOLO',
  PROCESSO_DIGITAL = 'PROCESSO_DIGITAL'
}
